import { useState, useEffect, useRef } from "react";
import { db, auth, googleProvider } from "./firebase";
import { signInWithPopup, signOut, onAuthStateChanged } from "firebase/auth";
import {
  collection, addDoc, updateDoc, deleteDoc,
  doc, onSnapshot, query, orderBy
} from "firebase/firestore";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const MONTHS = ["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec",
  "Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"];

const PKW = {
  "70.22.14.0": "Doradztwo w zakresie zarządzania",
  "70.22.20.0": "Pozostałe usługi zarządzania"
};

const PKW_RATE = { "70.22.14.0": "15%", "70.22.20.0": "8,5%" };
const PKW_RYCZALT = { "70.22.14.0": 0.15, "70.22.20.0": 0.085 };
const PKW_COLORS = { "70.22.14.0": "#6366f1", "70.22.20.0": "#10b981" };
const COLORS = ["#6366f1","#10b981","#f59e0b","#ef4444","#3b82f6","#8b5cf6","#ec4899","#14b8a6"];

const SUGGESTIONS = {
  "70.22.14.0": [
    "Doradztwo w zakresie strategii IT",
    "Konsultacje w zakresie architektury systemów informatycznych",
    "Doradztwo w zakresie transformacji cyfrowej",
    "Konsultacje w zakresie zarządzania projektami IT",
    "Doradztwo w zakresie optymalizacji procesów IT",
    "Konsultacje w zakresie bezpieczeństwa informacji",
    "Doradztwo w zakresie wdrożenia metodyk Agile/Scrum",
    "Konsultacje w zakresie zarządzania ryzykiem IT",
    "Doradztwo w zakresie polityki zakupów technologicznych",
    "Konsultacje w zakresie budżetowania i planowania IT",
  ],
  "70.22.20.0": [
    "Prowadzenie i nadzór nad projektem wdrożenia systemu informatycznego",
    "Planowanie i koordynacja harmonogramu projektu IT",
    "Nadzór nad realizacją i rozliczaniem projektu IT",
    "Koordynacja i nadzór nad pracą zespołu projektowego",
    "Zarządzanie portfelem projektów IT — planowanie i kontrola realizacji",
    "Planowanie i koordynacja migracji danych",
    "Nadzór i koordynacja procesu testowania oprogramowania",
    "Koordynacja i nadzór nad wdrożeniem infrastruktury chmurowej",
    "Nadzór nad integracją systemów informatycznych",
    "Koordynacja działań zespołów inżynierskich w projekcie IT",
  ]
};

function fmt(h) {
  const hh = Math.floor(h);
  const mm = Math.round((h - hh) * 60);
  return `${hh}h ${mm.toString().padStart(2,"0")}min`;
}

function today() { return new Date().toISOString().split("T")[0]; }

const plnFmt = v => v.toLocaleString("pl-PL", { minimumFractionDigits:2, maximumFractionDigits:2 }) + " zł";
const lbl = { display:"block", fontSize:12, fontWeight:600, color:"#475569", marginBottom:5, marginTop:14 };
const inp = { width:"100%", padding:"10px 12px", borderRadius:9, border:"1.5px solid #e2e8f0", fontSize:14, color:"#1e293b", boxSizing:"border-box", background:"#f8fafc" };
const sel = { flex:1, padding:"9px 12px", borderRadius:9, border:"1.5px solid #e2e8f0", fontSize:13, color:"#1e293b", background:"#fff", cursor:"pointer" };
const iconBtn = (bg, color) => ({ padding:"6px 9px", background:bg, color, border:"none", borderRadius:8, cursor:"pointer", fontSize:14 });
const colHd = { fontSize:11, fontWeight:700, color:"#94a3b8", textTransform:"uppercase", letterSpacing:0.5, padding:"8px 10px", textAlign:"right" };
const cell = { padding:"12px 10px", fontSize:13, textAlign:"right", color:"#1e293b" };
const cellL = { ...cell, textAlign:"left" };

function LoginScreen({ onLogin, error }) {
  return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"100vh", background:"#f8fafc", fontFamily:"'Segoe UI', sans-serif" }}>
      <div style={{ background:"#fff", borderRadius:20, padding:"48px 40px", boxShadow:"0 4px 24px #00000015", textAlign:"center", maxWidth:380, width:"100%" }}>
        <div style={{ fontSize:48, marginBottom:16 }}>⏱</div>
        <h1 style={{ margin:"0 0 8px", fontSize:24, fontWeight:700, color:"#1e293b" }}>Tracker Usług</h1>
        <p style={{ margin:"0 0 32px", color:"#94a3b8", fontSize:14 }}>Zaloguj się aby uzyskać dostęp</p>
        <button onClick={onLogin} style={{
          width:"100%", padding:"12px 24px", borderRadius:12, border:"1.5px solid #e2e8f0",
          background:"#fff", cursor:"pointer", fontSize:15, fontWeight:600, color:"#1e293b",
          display:"flex", alignItems:"center", justifyContent:"center", gap:12
        }}>
          <svg width="20" height="20" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Zaloguj się przez Google
        </button>
        {error && <p style={{ marginTop:16, color:"#ef4444", fontSize:13 }}>{error}</p>}
      </div>
    </div>
  );
}

function BarRow({ label, sublabel, hrs, pct, color }) {
  return (
    <div style={{ background:"#fff", borderRadius:12, padding:"14px 16px", marginBottom:8, boxShadow:"0 1px 3px #00000010" }}>
      <div style={{ display:"flex", justifyContent:"space-between", marginBottom:8 }}>
        <div style={{ display:"flex", alignItems:"center", gap:8 }}>
          <div style={{ width:12, height:12, borderRadius:3, background:color, flexShrink:0 }}/>
          <div>
            <div style={{ fontWeight:600, fontSize:14, color:"#1e293b" }}>{label}</div>
            {sublabel && <div style={{ fontSize:11, color:"#94a3b8" }}>{sublabel}</div>}
          </div>
        </div>
        <div style={{ textAlign:"right" }}>
          <span style={{ fontWeight:700, color, fontSize:14 }}>{pct.toFixed(1)}%</span>
          <span style={{ color:"#94a3b8", fontSize:12, marginLeft:8 }}>{fmt(hrs)}</span>
        </div>
      </div>
      <div style={{ background:"#f1f5f9", borderRadius:99, height:8, overflow:"hidden" }}>
        <div style={{ width:`${pct}%`, height:"100%", background:color, borderRadius:99, transition:"width 0.5s ease" }}/>
      </div>
    </div>
  );
}

function InvoiceCalc({ byPkwiu, totalHours }) {
  const [netTotal, setNetTotal] = useState("");
  const net = parseFloat(netTotal) || 0;
  const rows = Object.entries(byPkwiu).sort((a,b) => b[1]-a[1]).map(([code, hrs]) => {
    const pct = totalHours > 0 ? hrs / totalHours : 0;
    const netto = net * pct;
    const rate = PKW_RYCZALT[code] || 0;
    const tax = netto * rate;
    return { code, pct, netto, rate, tax, afterTax: netto - tax };
  });
  return (
    <div style={{ background:"#fff", borderRadius:14, padding:20, marginTop:20, boxShadow:"0 1px 4px #00000012" }}>
      <div style={{ fontSize:12, fontWeight:700, color:"#64748b", textTransform:"uppercase", letterSpacing:1, marginBottom:16 }}>Kalkulator faktury</div>
      <label style={lbl}>Kwota netto za miesiąc (zł)</label>
      <input style={{ ...inp, marginBottom:16 }} type="number" min="0" placeholder="np. 15000"
        value={netTotal} onChange={e => setNetTotal(e.target.value)}/>
      {net > 0 && (
        <div style={{ overflowX:"auto" }}>
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead>
              <tr style={{ borderBottom:"2px solid #f1f5f9" }}>
                <th style={{ ...colHd, textAlign:"left" }}>Kod PKWiU</th>
                <th style={colHd}>Udział</th>
                <th style={colHd}>Kwota netto</th>
                <th style={colHd}>Ryczałt</th>
                <th style={colHd}>Podatek</th>
                <th style={colHd}>Na rękę</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(({ code, pct, netto, rate, tax, afterTax }) => (
                <tr key={code} style={{ borderBottom:"1px solid #f1f5f9" }}>
                  <td style={cellL}>
                    <div style={{ fontWeight:700, color:PKW_COLORS[code]||"#1e293b" }}>{code}</div>
                    <div style={{ fontSize:11, color:"#94a3b8", marginTop:2 }}>{PKW[code]}</div>
                  </td>
                  <td style={cell}>{(pct*100).toFixed(1)}%</td>
                  <td style={{ ...cell, fontWeight:700 }}>{plnFmt(netto)}</td>
                  <td style={cell}>
                    <span style={{ background:code==="70.22.14.0"?"#ede9fe":"#d1fae5", color:PKW_COLORS[code], padding:"2px 7px", borderRadius:6, fontWeight:700, fontSize:12 }}>
                      {(rate*100).toString().replace(".",",")}%
                    </span>
                  </td>
                  <td style={{ ...cell, color:"#ef4444" }}>−{plnFmt(tax)}</td>
                  <td style={{ ...cell, fontWeight:700, color:"#10b981" }}>{plnFmt(afterTax)}</td>
                </tr>
              ))}
              <tr style={{ borderTop:"2px solid #e2e8f0", background:"#f8fafc" }}>
                <td style={{ ...cellL, fontWeight:700 }}>Razem</td>
                <td style={{ ...cell, fontWeight:700 }}>100%</td>
                <td style={{ ...cell, fontWeight:700 }}>{plnFmt(net)}</td>
                <td style={cell}>—</td>
                <td style={{ ...cell, fontWeight:700, color:"#ef4444" }}>−{plnFmt(rows.reduce((s,r)=>s+r.tax,0))}</td>
                <td style={{ ...cell, fontWeight:700, color:"#10b981" }}>{plnFmt(rows.reduce((s,r)=>s+r.afterTax,0))}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default function App() {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [authError, setAuthError] = useState("");
  const [entries, setEntries] = useState([]);
  const [form, setForm] = useState({ service:"", pkwiu:"70.22.14.0", hours:"", minutes:"", date:today() });
  const [filterMonth, setFilterMonth] = useState(new Date().getMonth());
  const [filterYear, setFilterYear] = useState(new Date().getFullYear());
  const [tab, setTab] = useState("add");
  const [editId, setEditId] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [exporting, setExporting] = useState(false);
  const reportRef = useRef(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, u => {
      setUser(u);
      setAuthLoading(false);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (!user) return;
    const q = query(collection(db, "entries"), orderBy("date", "asc"));
    const unsub = onSnapshot(q, snapshot => {
      setEntries(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoaded(true);
    });
    return () => unsub();
  }, [user]);

  async function exportPDF() {
    if (!reportRef.current) return;
    setExporting(true);
    try {
      const canvas = await html2canvas(reportRef.current, { scale:2, useCORS:true, backgroundColor:"#f8fafc" });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({ orientation:"portrait", unit:"mm", format:"a4" });
      const pageW = pdf.internal.pageSize.getWidth();
      const pageH = pdf.internal.pageSize.getHeight();
      const margin = 10;
      const imgW = pageW - margin * 2;
      const imgH = (canvas.height * imgW) / canvas.width;
      if (imgH <= pageH - margin * 2) {
        pdf.addImage(imgData, "PNG", margin, margin, imgW, imgH);
      } else {
        let remainH = imgH;
        let srcY = 0;
        while (remainH > 0) {
          const sliceH = Math.min(remainH, pageH - margin * 2);
          const sliceCanvas = document.createElement("canvas");
          sliceCanvas.width = canvas.width;
          sliceCanvas.height = (sliceH / imgH) * canvas.height;
          const ctx = sliceCanvas.getContext("2d");
          ctx.drawImage(canvas, 0, srcY * (canvas.height / imgH), canvas.width, sliceCanvas.height, 0, 0, canvas.width, sliceCanvas.height);
          pdf.addImage(sliceCanvas.toDataURL("image/png"), "PNG", margin, margin, imgW, sliceH);
          remainH -= sliceH;
          srcY += sliceH;
          if (remainH > 0) pdf.addPage();
        }
      }
      pdf.save(`raport-${MONTHS[filterMonth]}-${filterYear}.pdf`);
    } catch(e) { console.error(e); }
    setExporting(false);
  }

  async function handleLogin() {
    setAuthError("");
    try { await signInWithPopup(auth, googleProvider); }
    catch(e) { setAuthError("Logowanie nie powiodło się. Spróbuj ponownie."); }
  }

  async function handleLogout() {
    await signOut(auth);
    setEntries([]);
    setLoaded(false);
  }

  async function handleSubmit() {
    const h = parseFloat(form.hours || 0);
    const m = parseFloat(form.minutes || 0);
    const total = h + m / 60;
    if (!form.service.trim() || total <= 0 || !form.date) return;
    const data = { service:form.service.trim(), pkwiu:form.pkwiu, hours:total, date:form.date };
    if (editId !== null) {
      await updateDoc(doc(db, "entries", editId), data);
      setEditId(null);
    } else {
      await addDoc(collection(db, "entries"), data);
    }
    setForm({ service:"", pkwiu:"70.22.14.0", hours:"", minutes:"", date:today() });
  }

  function startEdit(e) {
    const hh = Math.floor(e.hours), mm = Math.round((e.hours - hh) * 60);
    setForm({ service:e.service, pkwiu:e.pkwiu||"70.22.14.0", hours:String(hh), minutes:String(mm), date:e.date });
    setEditId(e.id);
    setTab("add");
  }

  async function remove(id) { await deleteDoc(doc(db, "entries", id)); }

  const filtered = entries.filter(e => {
    const d = new Date(e.date);
    return d.getMonth() === filterMonth && d.getFullYear() === filterYear;
  });

  const totalHours = filtered.reduce((s, e) => s + e.hours, 0);

  const byService = filtered.reduce((acc, e) => {
    acc[e.service] = (acc[e.service] || 0) + e.hours; return acc;
  }, {});

  const byPkwiu = filtered.reduce((acc, e) => {
    const k = e.pkwiu || "—";
    acc[k] = (acc[k] || 0) + e.hours; return acc;
  }, {});

  const years = [...new Set(entries.map(e => new Date(e.date).getFullYear()))].sort();
  if (!years.includes(filterYear)) years.push(filterYear);

  if (authLoading) return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:"100vh", color:"#6366f1", fontFamily:"'Segoe UI', sans-serif" }}>
      Ładowanie…
    </div>
  );

  if (!user) return <LoginScreen onLogin={handleLogin} error={authError}/>;

  if (!loaded) return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:"100vh", color:"#6366f1", fontFamily:"'Segoe UI', sans-serif" }}>
      Łączenie z bazą danych…
    </div>
  );

  return (
    <div style={{ fontFamily:"'Segoe UI', sans-serif", maxWidth:680, margin:"0 auto", padding:16, background:"#f8fafc", minHeight:"100vh" }}>
      <div style={{ background:"linear-gradient(135deg,#6366f1,#8b5cf6)", borderRadius:16, padding:"20px 24px", marginBottom:20, color:"#fff", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <div>
          <h1 style={{ margin:0, fontSize:22, fontWeight:700 }}>⏱ Tracker Usług</h1>
          <p style={{ margin:"4px 0 0", opacity:0.85, fontSize:13 }}>{user.email}</p>
        </div>
        <button onClick={handleLogout} style={{
          padding:"8px 16px", background:"rgba(255,255,255,0.2)", color:"#fff",
          border:"1.5px solid rgba(255,255,255,0.4)", borderRadius:10, cursor:"pointer", fontSize:13, fontWeight:600
        }}>Wyloguj</button>
      </div>

      <div style={{ display:"flex", gap:8, marginBottom:20 }}>
        {[["add", editId ? "✏️ Edytuj" : "➕ Dodaj"], ["list","📋 Wpisy"], ["report","📊 Raport"]].map(([k,label]) => (
          <button key={k} onClick={() => setTab(k)} style={{
            flex:1, padding:"10px 8px", borderRadius:10, border:"none", cursor:"pointer", fontWeight:600, fontSize:13,
            background:tab===k?"#6366f1":"#fff", color:tab===k?"#fff":"#475569",
            boxShadow:tab===k?"0 2px 8px #6366f140":"0 1px 3px #00000015"
          }}>{label}</button>
        ))}
      </div>

      {/* DODAJ */}
      {tab === "add" && (
        <div style={{ background:"#fff", borderRadius:14, padding:20, boxShadow:"0 1px 4px #00000012" }}>
          <h2 style={{ margin:"0 0 16px", fontSize:16, color:"#1e293b" }}>{editId ? "Edytuj wpis" : "Nowy wpis"}</h2>
          <label style={lbl}>Kod PKWiU</label>
          <div style={{ display:"flex", gap:8, marginBottom:4 }}>
            {Object.keys(PKW).map(code => (
              <button key={code} onClick={() => setForm(f => ({ ...f, pkwiu:code }))} style={{
                flex:1, padding:"10px 8px", borderRadius:10,
                border:`2px solid ${form.pkwiu===code ? PKW_COLORS[code] : "#e2e8f0"}`,
                background:form.pkwiu===code ? (code==="70.22.14.0" ? "#ede9fe" : "#d1fae5") : "#f8fafc",
                color:form.pkwiu===code ? PKW_COLORS[code] : "#64748b",
                fontWeight:700, fontSize:12, cursor:"pointer"
              }}>
                <div>{code}</div>
                <div style={{ fontSize:11, opacity:0.8, marginTop:2 }}>ryczałt {PKW_RATE[code]}</div>
              </button>
            ))}
          </div>
          <div style={{ fontSize:11, color:"#94a3b8", marginBottom:4 }}>{PKW[form.pkwiu]}</div>
          <label style={lbl}>Opis usługi</label>
          <input style={inp} placeholder="Wpisz lub wybierz z listy…" value={form.service}
            onChange={e => setForm(f => ({ ...f, service:e.target.value }))} list="service-suggestions"/>
          <datalist id="service-suggestions">
            {SUGGESTIONS[form.pkwiu].map(s => <option key={s} value={s}/>)}
          </datalist>
          <label style={lbl}>Czas realizacji</label>
          <div style={{ display:"flex", gap:10 }}>
            <input style={{ ...inp, flex:1 }} type="number" min="0" placeholder="Godziny" value={form.hours}
              onChange={e => setForm(f => ({ ...f, hours:e.target.value }))}/>
            <input style={{ ...inp, flex:1 }} type="number" min="0" max="59" placeholder="Minuty (0–59)" value={form.minutes}
              onChange={e => setForm(f => ({ ...f, minutes:e.target.value }))}/>
          </div>
          <label style={lbl}>Data</label>
          <input style={inp} type="date" value={form.date}
            onChange={e => setForm(f => ({ ...f, date:e.target.value }))}/>
          <div style={{ display:"flex", gap:8, marginTop:16 }}>
            <button onClick={handleSubmit} style={{
              flex:1, padding:11, background:"#6366f1", color:"#fff", border:"none",
              borderRadius:10, fontWeight:700, fontSize:14, cursor:"pointer"
            }}>{editId ? "Zapisz zmiany" : "Dodaj wpis"}</button>
            {editId && (
              <button onClick={() => { setEditId(null); setForm({ service:"", pkwiu:"70.22.14.0", hours:"", minutes:"", date:today() }); }} style={{
                padding:"11px 16px", background:"#f1f5f9", color:"#475569", border:"none",
                borderRadius:10, fontWeight:600, fontSize:13, cursor:"pointer"
              }}>Anuluj</button>
            )}
          </div>
        </div>
      )}

      {/* WPISY */}
      {tab === "list" && (
        <div>
          <div style={{ display:"flex", gap:8, marginBottom:14 }}>
            <select style={sel} value={filterMonth} onChange={e => setFilterMonth(+e.target.value)}>
              {MONTHS.map((m,i) => <option key={i} value={i}>{m}</option>)}
            </select>
            <select style={sel} value={filterYear} onChange={e => setFilterYear(+e.target.value)}>
              {years.map(y => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>
          {filtered.length === 0
            ? <div style={{ textAlign:"center", padding:40, color:"#94a3b8", background:"#fff", borderRadius:14 }}>Brak wpisów w tym miesiącu</div>
            : [...filtered].sort((a,b) => a.date.localeCompare(b.date)).map(e => (
              <div key={e.id} style={{ background:"#fff", borderRadius:12, padding:"14px 16px", marginBottom:8, display:"flex", alignItems:"center", gap:12, boxShadow:"0 1px 3px #00000010" }}>
                <div style={{ width:4, alignSelf:"stretch", borderRadius:99, background:PKW_COLORS[e.pkwiu]||"#cbd5e1", flexShrink:0 }}/>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontWeight:600, color:"#1e293b", fontSize:14 }}>{e.service}</div>
                  <div style={{ fontSize:11, color:PKW_COLORS[e.pkwiu]||"#94a3b8", marginTop:1, fontWeight:600 }}>{e.pkwiu}</div>
                  <div style={{ fontSize:11, color:"#94a3b8", marginTop:1 }}>{new Date(e.date).toLocaleDateString("pl-PL")}</div>
                </div>
                <div style={{ fontWeight:700, color:"#6366f1", fontSize:14, flexShrink:0 }}>{fmt(e.hours)}</div>
                <button onClick={() => startEdit(e)} style={iconBtn("#ede9fe","#6366f1")}>✏️</button>
                <button onClick={() => remove(e.id)} style={iconBtn("#fee2e2","#ef4444")}>🗑️</button>
              </div>
            ))
          }
        </div>
      )}

      {/* RAPORT */}
      {tab === "report" && (
        <div>
          <div style={{ display:"flex", gap:8, marginBottom:14, alignItems:"center" }}>
            <div style={{ display:"flex", gap:8, flex:1 }}>
              <select style={sel} value={filterMonth} onChange={e => setFilterMonth(+e.target.value)}>
                {MONTHS.map((m,i) => <option key={i} value={i}>{m}</option>)}
              </select>
              <select style={sel} value={filterYear} onChange={e => setFilterYear(+e.target.value)}>
                {years.map(y => <option key={y} value={y}>{y}</option>)}
              </select>
            </div>
            <button onClick={exportPDF} disabled={exporting || filtered.length === 0} style={{
              padding:"9px 16px", background:filtered.length === 0 ? "#e2e8f0" : "#6366f1",
              color:filtered.length === 0 ? "#94a3b8" : "#fff", border:"none",
              borderRadius:10, fontWeight:700, fontSize:13, cursor:filtered.length === 0 ? "not-allowed" : "pointer",
              whiteSpace:"nowrap"
            }}>{exporting ? "Generuję…" : "⬇ PDF"}</button>
          </div>

          <div ref={reportRef} style={{ background:"#f8fafc", padding:4 }}>
            {filtered.length === 0
              ? <div style={{ textAlign:"center", padding:40, color:"#94a3b8", background:"#fff", borderRadius:14 }}>Brak danych w tym miesiącu</div>
              : <>
                <div style={{ background:"linear-gradient(135deg,#6366f1,#8b5cf6)", borderRadius:14, padding:"18px 20px", marginBottom:16, color:"#fff" }}>
                  <div style={{ fontSize:13, opacity:0.85 }}>Raport miesięczny</div>
                  <div style={{ fontSize:22, fontWeight:800, marginTop:2 }}>{MONTHS[filterMonth]} {filterYear}</div>
                  <div style={{ display:"flex", gap:24, marginTop:8 }}>
                    <div>
                      <div style={{ fontSize:11, opacity:0.75 }}>Łączny czas</div>
                      <div style={{ fontSize:20, fontWeight:700 }}>{fmt(totalHours)}</div>
                    </div>
                    <div>
                      <div style={{ fontSize:11, opacity:0.75 }}>Liczba wpisów</div>
                      <div style={{ fontSize:20, fontWeight:700 }}>{filtered.length}</div>
                    </div>
                  </div>
                </div>

                <div style={{ fontSize:12, fontWeight:700, color:"#64748b", textTransform:"uppercase", letterSpacing:1, marginBottom:8 }}>Podział wg kodu PKWiU</div>
                {Object.entries(byPkwiu).sort((a,b) => b[1]-a[1]).map(([code, hrs]) => (
                  <BarRow key={code} label={code} sublabel={PKW[code]} hrs={hrs}
                    pct={totalHours > 0 ? hrs/totalHours*100 : 0} color={PKW_COLORS[code]||"#94a3b8"}/>
                ))}

                <div style={{ fontSize:12, fontWeight:700, color:"#64748b", textTransform:"uppercase", letterSpacing:1, margin:"18px 0 8px" }}>Podział wg opisu usługi</div>
                {Object.entries(byService).sort((a,b) => b[1]-a[1]).map(([name, hrs], i) => (
                  <BarRow key={name} label={name} hrs={hrs}
                    pct={totalHours > 0 ? hrs/totalHours*100 : 0} color={COLORS[i % COLORS.length]}/>
                ))}

                <div style={{ fontSize:12, fontWeight:700, color:"#64748b", textTransform:"uppercase", letterSpacing:1, margin:"18px 0 8px" }}>Lista wpisów</div>
                <div style={{ background:"#fff", borderRadius:14, overflow:"hidden", boxShadow:"0 1px 4px #00000012" }}>
                  {[...filtered].sort((a,b) => a.date.localeCompare(b.date)).map((e, i) => (
                    <div key={e.id} style={{ display:"flex", alignItems:"center", gap:12, padding:"11px 16px", borderBottom:i < filtered.length-1 ? "1px solid #f1f5f9" : "none" }}>
                      <div style={{ width:4, height:36, borderRadius:99, background:PKW_COLORS[e.pkwiu]||"#cbd5e1", flexShrink:0 }}/>
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ fontWeight:600, color:"#1e293b", fontSize:13 }}>{e.service}</div>
                        <div style={{ fontSize:11, color:"#94a3b8", marginTop:1 }}>{new Date(e.date).toLocaleDateString("pl-PL")} · {e.pkwiu}</div>
                      </div>
                      <div style={{ fontWeight:700, color:"#6366f1", fontSize:13, flexShrink:0 }}>{fmt(e.hours)}</div>
                    </div>
                  ))}
                </div>

                <InvoiceCalc byPkwiu={byPkwiu} totalHours={totalHours} />
              </>
            }
          </div>
        </div>
      )}
    </div>
  );
}